<template>
  <div>
    <div class="v-table__overflow res-table">
    <table class="v-table theme--light" v-if="records">
      <thead>
        <tr>
          <th class="table-distance">Typ</th>
          <th class="table-distance">Dystans</th>
          <th class="table-time">Czas</th>
          <th class="table-date">Data</th>
          <th class="table-actions"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="record in records" >
          <tr class="detail-row" v-if="!record.edit" @click="$emit('set-distance', record.distance_string)">
            <td>{{ record.race_type_name }}</td>
            <td>{{ record.distance_string_name }}</td>
            <td>{{ record.time }}</td>
            <td>{{ record.race_date | formatDate('LL') }}</td>
            <td>
              <rp-icon
                type="edit"
                tooltip="edytuj"
                class="mr-2"
                @click.native.prevent.stop="record.edit = !record.edit"
              />
            </td>
          </tr>
          <record-form v-else class="edit-row" @close="record.edit = !record.edit" :record="record" @created-record="refetchView" @updated-record="refetchView">
          </record-form>
        </template>
        <template v-if="newRecord">
          <record-form class="edit-row" @close="newRecord = !newRecord"  @created-record="refetchView" @updated-record="refetchView">
          </record-form>
        </template>
      </tbody>
    </table>
    </div>
    <rp-icon
      type="add_circle"
      tooltip="dodaj"
      class="mr-2"
      @click="newRecord = !newRecord"
    />
  </div>
</template>
<script>
import {fetchRecords} from '@/plan/api'
import { mapState, mapGetters } from 'vuex'
import ResultsChart from './ResultsChart'
import RecordForm from './RecordForm'

export default {
  components: {ResultsChart, RecordForm},
  data () {
    return {
      newRecord: false,
      newRecordObj: {},
      records: []
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['allRaceDistanceStringsOptions'])
  },
  created () {
    this.refetchView()
  },
  watch: {
    '$route': 'refetchView'
  },
  methods: {
    submitRecord () {
    },
    refetchView () {
      this.fetchRecordsList()
      this.newRecord = false
    },
    fetchRecordsList () {
      let promise = fetchRecords(this.runner, {})
      return promise.then((data) => {
        this.records = data.results
        for (let r of this.records) {
          this.$set(r, 'edit', false)
        }
      })
    }
  }
}
</script>
<style>
.table-distance {
  min-width: 200px;
}
.table-time {
  min-width: 160px;
}
.table-date {
  min-width: 200px;
}
.table-actions {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/results/Records.vue